module.exports = __webpack_public_path__ + "img/hbicon.f2b8a166.png";